import { SubmitButton } from "@xola/ui-kit";
import { useFormikContext } from "formik";
import React from "react";
import { NotifyCustomerCheckbox } from "../../Common/NotifyCustomerCheckbox";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { SplitPayFormValues, SplitPayOptions } from "./CreatePurchaseSplitPayTypes";

interface CreateSplitPayPurchaseFooterProps {
    isSavingPurchaseBalance: boolean;
    isSavingCustomAmount: boolean;
    customAmountSuccess: boolean;
    purchaseBalanceSuccess: boolean;
    onClose: () => void;
}

export const CreateSplitPayPurchaseFooter = ({
    isSavingPurchaseBalance,
    isSavingCustomAmount,
    customAmountSuccess,
    purchaseBalanceSuccess,
    onClose,
}: CreateSplitPayPurchaseFooterProps) => {
    const { values, setFieldValue, handleSubmit } = useFormikContext<SplitPayFormValues>();
    const { splitPayOption, notify, amount } = values;

    const handleRemainingBalanceChange = () => {
        setFieldValue("isPayAndAddOption", false);
        handleSubmit();
    };

    const handlePayAndAddGuest = async () => {
        setFieldValue("isPayAndAddOption", true);
        handleSubmit();
    };

    return (
        <>
            <div className="mr-auto">
                <NotifyCustomerCheckbox
                    isChecked={notify}
                    onChange={(e) => {
                        setFieldValue("notify", e.target.checked);
                    }}
                />
            </div>
            <SecondaryButton onClick={onClose}>Skip</SecondaryButton>
            {/* TODO the secondary outline button shows spinner with grey background, this will be fixed in ui-kit */}
            <SubmitButton
                customAmountSuccess
                variant={splitPayOption === SplitPayOptions.REMAINING_BALANCE ? "standard" : "outline"}
                color={splitPayOption === SplitPayOptions.REMAINING_BALANCE ? "success" : "secondary"}
                isLoading={isSavingPurchaseBalance}
                isSuccess={purchaseBalanceSuccess}
                disabled={amount <= 0}
                onClick={handleRemainingBalanceChange}
            >
                Pay and Finish
            </SubmitButton>
            {splitPayOption !== SplitPayOptions.REMAINING_BALANCE && (
                <SubmitButton
                    color="success"
                    type="submit"
                    isLoading={isSavingCustomAmount}
                    isSuccess={customAmountSuccess}
                    disabled={amount <= 0}
                    onClick={handlePayAndAddGuest}
                >
                    Pay and Add Another Guest
                </SubmitButton>
            )}
        </>
    );
};
